import { Button, Checkbox, ClickAwayListener, createStyles, makeStyles, Paper, Popper, TextField } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey.js';
import { Delete } from '@material-ui/icons';
import React, { useState } from 'react';
import { AnnotationWrapper, useDocumentPermissions } from "../../index.js";
import { useLocalization, useViewerState } from "../../hooks/index.js";
const useStyles = makeStyles(theme => {
  return createStyles({
    annotationInput: {
      width: '100%',
      height: '100%',
      overflow: 'auto',
      '&:focus': {
        outline: 'none'
      },
      writingMode: _ref => {
        let {
          rotationDegree
        } = _ref;
        return rotationDegree === 0 || rotationDegree === 180 ? 'unset' : 'vertical-rl';
      },
      transform: _ref2 => {
        let {
          rotationDegree
        } = _ref2;
        return rotationDegree === 180 || rotationDegree === 270 ? 'rotate(180deg)' : 'none';
      }
    },
    title: {
      fontSize: '12px',
      marginRight: '6px'
    },
    textBox: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '6px'
    },
    textField: {
      width: '55px'
    },
    paper: {
      padding: '10px',
      marginLeft: '10px',
      border: `solid ${grey[600]} 2px`
    },
    button: {
      backgroundColor: theme.palette.error.light
    }
  });
});
/**
 * Defined the component's own properties
 */

export const ShapeAnnotation = props => {
  var _viewerState$rotation, _viewerState$rotation2;

  const viewerState = useViewerState();
  const rotationDegree = ((_viewerState$rotation = viewerState.rotation) === null || _viewerState$rotation === void 0 ? void 0 : (_viewerState$rotation2 = _viewerState$rotation.find(rotation => rotation.pageNum === props.shape.imageIndex)) === null || _viewerState$rotation2 === void 0 ? void 0 : _viewerState$rotation2.degree) || 0;
  const classes = useStyles({
    rotationDegree
  });
  const localization = useLocalization();
  const permissions = useDocumentPermissions();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'annotation-settings' : undefined;

  const getDimensions = () => {
    const dimensions = props.getShapeDimensions(props.shape);
    return {
      top: dimensions.top,
      left: dimensions.left,
      width: dimensions.width,
      height: dimensions.height
    };
  };

  const onRightClick = event => {
    event.preventDefault();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnnotationWrapper, {
    shape: props.shape,
    zoomRatio: props.zoomRatio,
    dimensions: getDimensions(),
    onRightClick: onRightClick,
    onDragStart: props.onDragStart,
    onResized: props.onResized,
    rotationDegree: props.rotationDegree
  }, /*#__PURE__*/React.createElement("div", {
    id: "annotation-input",
    className: classes.annotationInput,
    contentEditable: permissions.canEdit && rotationDegree === 0 ? 'plaintext-only' : false,
    suppressContentEditableWarning: true
  }, props.shape.text)), /*#__PURE__*/React.createElement(Popper, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    placement: "right-start"
  }, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: () => setAnchorEl(null)
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.textBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Line height:"), /*#__PURE__*/React.createElement(TextField, {
    className: classes.textField,
    defaultValue: props.shape.lineHeight,
    size: "small",
    placeholder: "Line height",
    type: "number",
    onChange: event => props.updateShapeData('annotations', props.shape.guid, { ...props.shape,
      lineHeight: parseInt(event.target.value, 10)
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "px")), /*#__PURE__*/React.createElement("div", {
    className: classes.textBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Font size:"), /*#__PURE__*/React.createElement(TextField, {
    className: classes.textField,
    defaultValue: props.shape.fontSize,
    size: "small",
    placeholder: "Font size",
    type: "number",
    onChange: event => props.updateShapeData('annotations', props.shape.guid, { ...props.shape,
      fontSize: parseInt(event.target.value, 10)
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "px")), /*#__PURE__*/React.createElement("div", {
    className: classes.textBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Font bold:"), /*#__PURE__*/React.createElement(TextField, {
    className: classes.textField,
    defaultValue: props.shape.fontBold,
    size: "small",
    placeholder: "Font bold",
    type: "number",
    onChange: event => props.updateShapeData('annotations', props.shape.guid, { ...props.shape,
      fontBold: parseInt(event.target.value, 10)
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Font color:"), /*#__PURE__*/React.createElement(TextField, {
    className: classes.textField,
    defaultValue: props.shape.fontColor,
    size: "small",
    placeholder: "Font color",
    type: "color",
    onChange: event => props.updateShapeData('annotations', props.shape.guid, { ...props.shape,
      fontColor: event.target.value
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Font italic:"), /*#__PURE__*/React.createElement(Checkbox, {
    checked: props.shape.fontItalic,
    onChange: event => props.updateShapeData('annotations', props.shape.guid, { ...props.shape,
      fontItalic: event.target.checked
    }),
    name: "fontItalic",
    color: "primary"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textBox,
    style: {
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    className: classes.button,
    onMouseUp: () => props.removeShape('annotations', props.shape.guid),
    startIcon: /*#__PURE__*/React.createElement(Delete, {
      scale: props.zoomRatio
    })
  }, localization.delete))))));
};
//# sourceMappingURL=shape-annotation.js.map